import { useContext } from 'react'
import { ApplicationContext } from '../helpers/context'

export const useRepresentative = () => {
  const { user } = useContext(ApplicationContext)
  return user
}

export default useRepresentative